<script lang="ts">import Accordion from '../Accordion/Accordion.svelte';
import Section from '../Section/Section.svelte';
import Text from '../Typography/Text/Text.svelte';
const { colorMode = 'light', headingText = '', isFirstItemOpen = false, onClick = () => { }, items = [], content: contentFromProps, class: className = '', ...rest } = $props();
</script>

<Section {...rest} class="Faq {className}" {colorMode} {headingText} variant="secondary">
  <Accordion isFirstItemOpenByDefault={isFirstItemOpen} {onClick} {items}>
    {#snippet summary({ question })}
      <Text as="h3" variant="200" isBalanced={true}>
        {question}
      </Text>
    {/snippet}
    {#snippet content({ answer })}
      {@render contentFromProps?.({ answer })}
    {/snippet}
  </Accordion>
</Section>

<style>@layer design-system-components.pwds {
  :global(.Faq) :global(.AccordionItem__content) {
    max-width: var(--faq-accordion-item-max-width);
    padding-bottom: var(--faq-accordion-item-content-padding-bottom);
  }
  :global(.Faq) :global(.AccordionItem__content) :global(p) {
    --max-width: none;
  }
  :global(.Faq) :global(.AccordionItem__content) :global(a:not(.Action)) {
    font-weight: var(--text-font-weight-regular);
  }
}</style>
